import WagmiWrap from './WagmiWrap';
import { Icon } from '@iconify/react';
import { disconnect } from '@wagmi/core'

function InsideApp(props){
	var clickBack = props.clickBack;
	function cClick(e){
		disconnect()
		clickBack();
	}
	return <span className='topMenu' onClick={cClick} ><Icon width = "25" icon="icon-park-outline:preview-open" />&nbsp;&nbsp;Exit Preview Mode</span>
}
//

function App(props){
	var clickBack = props.clickBack;
	var inside = <InsideApp clickBack={clickBack}/>

	return <WagmiWrap inside={inside} chains={[]} currencyID={0}/>
}

export default App;